import { render, staticRenderFns } from "./atasanLangsungBoard.vue?vue&type=template&id=03806715&"
import script from "./atasanLangsungBoard.vue?vue&type=script&lang=js&"
export * from "./atasanLangsungBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports